import React, {Component} from 'react';
import {PropTypes} from 'prop-types';
import * as messageConstants from "../../../shared/messages";
import AcrValueAutocomplete from './AcrValueAutocomplete';

class AcrWorkflowRow extends Component {
    static propTypes = {
        id: PropTypes.number,
        rowObject: PropTypes.object,
        workflows: PropTypes.array,
        predefinedAcrWorkflow: PropTypes.array,
        onChange: PropTypes.func,
        onRemove: PropTypes.func,
    };

    state = {
        acrValuesSupported: [],
        workflowLocked: false
    };

    componentDidMount() {
        if (this.state.acrValuesSupported.length === 0) {
            this.setState({
                acrValuesSupported: (this.props.predefinedAcrWorkflow || []).map(el => el.acrValue)
            });
        }
        const currentAcr = this.props.rowObject.acrValue;
        if (currentAcr) {
            this.updateLockAndAutoSelect(currentAcr, false);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.predefinedAcrWorkflow !== this.props.predefinedAcrWorkflow) {
            this.setState({
                acrValuesSupported: (this.props.predefinedAcrWorkflow || []).map(el => el.acrValue)
            });
            if (this.props.rowObject.acrValue) {
                this.updateLockAndAutoSelect(this.props.rowObject.acrValue, true);
            }
        }
        if (prevProps.workflows !== this.props.workflows && this.state.workflowLocked) {
            const currentAcr = this.props.rowObject.acrValue;
            if (currentAcr) {
                this.updateLockAndAutoSelect(currentAcr, true);
            }
        }
        if (prevProps.rowObject.acrValue !== this.props.rowObject.acrValue) {
            this.updateLockAndAutoSelect(this.props.rowObject.acrValue, true);
        }
    }

    updateLockAndAutoSelect = (acrValue, invokeOnChange) => {
        const rule = acrValue ? this.props.predefinedAcrWorkflow.find(el => el.acrValue === acrValue) : undefined;
        const shouldLock = !!(rule && rule.isRegulated);
        let updatedRowObject = this.props.rowObject;

        if (rule && rule.workflow.workflowCode) {
            const matchedWorkflow = (this.props.workflows || []).find(w => w.workflowCode === rule.workflow.workflowCode);
            if (matchedWorkflow && (!this.props.rowObject.workflow || this.props.rowObject.workflow.workflowCode !== matchedWorkflow.workflowCode)) {
                updatedRowObject = { ...this.props.rowObject, workflow: matchedWorkflow };
                if (invokeOnChange) {
                    this.props.onChange(this.props.id, updatedRowObject);
                }
            }
        }
        if (this.state.workflowLocked !== shouldLock) {
            this.setState({ workflowLocked: shouldLock });
        }
    };

    handleAcrValueChange = (acrValue) => {
        const updatedRowObject = { ...this.props.rowObject, acrValue };
        this.props.onChange(this.props.id, updatedRowObject);
        this.updateLockAndAutoSelect(acrValue, false);
    };

    handleWorkflowChange = (e) => {
        if (this.state.workflowLocked) return;
        const selectedWorkflow = (this.props.workflows || []).find(
            wf => wf.workflowCode === e.target.value
        );
        const updatedRowObject = { ...this.props.rowObject, workflow: selectedWorkflow };
        this.props.onChange(this.props.id, updatedRowObject);
    };

    handleRemove = () => {
        this.props.onRemove(this.props.id);
    };

    render() {
        const { workflowLocked, acrValuesSupported } = this.state;
        const row = this.props.rowObject || {};
        const currentWorkflowName = row.workflow ? row.workflow.workflowCode : '';
        const workflows = this.props.workflows || [];
        const acrValue = row.acrValue || '';

        return (
            <tr>
                <td className="pb-12">
                    <AcrValueAutocomplete
                        value={acrValue}
                        options={acrValuesSupported}
                        placeholder={messageConstants.ACR_VALUE_PLACEHOLDER}
                        className= 'acr-input form-control attributes-input'
                        onChange={this.handleAcrValueChange}
                    />
                </td>
                <td className="pl-12 pb-12">
                    <select
                        value={currentWorkflowName}
                        onChange={this.handleWorkflowChange}
                        disabled={workflowLocked}
                        className="workflow-name-input form-control attributes-input"
                    >
                        {workflows.map(wf => (
                            <option key={wf.id} value={wf.workflowCode}>{wf.workflowName}</option>
                        ))}
                    </select>
                </td>
                <td className="td-blank" />
                <td className="pl-12 pb-12 pr-12">
                    {row.isDefault === true ? (
                        <span className="default-action-message">
                            {messageConstants.DEFAULT_ACTION}
                        </span>
                    ) : (
                        <div className="remove-attribute-col">
                            <button
                                type="button"
                                onClick={this.handleRemove}
                                className="attr-button dell-button"
                            >
                                <span className="fa fa-minus btn-circle btn-minus" />
                                <span className="attr-button-label">
                                    {messageConstants.BUTTON_REMOVE_ACR}
                                </span>
                            </button>
                        </div>
                    )}
                </td>
            </tr>
        );
    }
}

export default AcrWorkflowRow;
